import { Box, IconButton } from "@mui/material";
import { TooltipIcon } from "src/Icons";
import { CustomTooltip } from "src/styledComponents";

import { CustomAddressCellProps } from "./CustomAddressCell.types";

export function CustomAddressCell ({ address }: CustomAddressCellProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: '100%',
      }}
    >
      <span
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {`${address || 'Not selected'}`}
      </span>

      {address?.length > 25 ? (
        <CustomTooltip
          title={
            <Box
              display="flex"
              flexDirection="row"
              sx={{
                flexWrap: 'wrap',
              }}
            >
              {address}
            </Box>
          }
          placement="bottom-end"
        >
          <IconButton
            className="tooltip-button"
            sx={{
              padding: 0,
              color: '#4F4F4F',
              fontSize: '16px',
              '&:hover': {
                color: '#BF295C',
                backgroundColor: 'transparent',
              },
            }}
          >
            <TooltipIcon fontSize="inherit" />
          </IconButton>
        </CustomTooltip>
      ) : null}
    </Box>
  );
}